import { Route, Routes, useLocation } from 'react-router-dom'
import Error404  from './containers/errors/Error404';
import Home from './containers/pages/Home';
import Distribuidor from './containers/pages/Distribuidor';
import About from './containers/pages/About';
import Contacto from './containers/pages/Contacto';
import Thanks from './containers/pages/Thanks';
import Showroom from './containers/pages/Showroom';
import ProductosNuevos from './containers/pages/ProductosNuevos';
import NoticiaNovedades from './containers/pages/NoticiaNovedades';
import VideosNovedades from './containers/pages/VideosNovedades';
import PoliticaPrivacidad from './containers/pages/PoliticaPrivacidad';
import TerminosCondiciones from './containers/pages/TerminosCondiciones';

import ScrollToTopButton from './components/scrollToToButton/ScrollToTopButton';

import { AnimatePresence } from 'framer-motion';

function AnimatedRoutes(){

    const location = useLocation()

    return(
            <AnimatePresence>
                <Routes location={location} key={location.pathname}>
                <Route path='*' element={<Error404/>} />
                <Route path='/' element={<Home/>} />
                <Route path='/distribuidor' element={<Distribuidor/>} />
                <Route path='/about' element={<About/>} />
                <Route path='/contacto' element={<Contacto/>} />
                <Route path='/showroom' element={<Showroom/>} />
                <Route path='/thanks' element={<Thanks/>} />
                <Route path='/productos_nuevos' element={<ProductosNuevos/>} />
                <Route path='/noticias_novedades' element={<NoticiaNovedades/>} />
                <Route path='/videos_novedades' element={<VideosNovedades/>} />
                <Route path='/politica-privacidad' element={<PoliticaPrivacidad/>} />
                <Route path='/politica-de-privacidad' element={<PoliticaPrivacidad/>} />
                <Route path='/terminos' element={<TerminosCondiciones/>} />
                <Route path='/terminos-y-condiciones' element={<TerminosCondiciones/>} />
                </Routes>
                <ScrollToTopButton />
            </AnimatePresence>
    );
}

export default AnimatedRoutes;